import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton/FlatButton'

import Utils from 'billing/infra/Utils'

export default class BillingItemDeletionConfirmationDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    billingEntity: PropTypes.string.isRequired,
    onCloseRequested: PropTypes.func.isRequired,
    onDialogResult: PropTypes.func.isRequired
  }
  
  handleDialogResult = (event, result) => {
    event.preventDefault()
    this.props.onDialogResult(result)
  }

  render() {
    if (!this.props.open) {
      return null
    }
    return (
      <Dialog
        actions={[
          <FlatButton
            key='no'
            label='No'
            primary={true}
            onTouchTap={event => this.handleDialogResult(event, false)} />,
          <FlatButton
            key='yes'
            label='Yes'
            primary={true}
            onTouchTap={event => this.handleDialogResult(event, true)} />
        ]}
        modal={false}
        open={this.props.open}
        contentStyle={{ maxWidth: 400 }}
        title={`Delete ${Utils.capitalize(this.props.billingEntity)}`}
        onRequestClose={this.props.onCloseRequested}>
        Are you sure you want to delete this {this.props.billingEntity}?
      </Dialog>
    )
  }

}



// WEBPACK FOOTER //
// ./src/billing/common/modules/items/BillingItemDeletionConfirmationDialog.js